import styled from 'styled-components';

interface StackedProps {
  toggled?: boolean;
}
const Stack = styled('span')<StackedProps>`
  display: block;
  position: absolute;
  right: ${({ theme }) => theme.x1space}rem;
  transition: all 0.3s ease-in-out;
`;

export const NAValue = styled(Stack)`
  color: ${({ toggled, theme }) =>
    toggled ? theme.color.brand01 : theme.color.white};
`;

export const AbsValue = styled(Stack)`
  transform-origin: bottom right;
  color: ${({ theme }) => theme.color.white};
  ${({ toggled }) =>
    toggled
      ? `
      transform: scale(0.8) translateY(50%);
    `
      : `
      transform: scale(1) translateY(0);
    `}
`;

export const TotalValue = styled(Stack)`
  color: ${({ theme }) => theme.color.brand01};
  transform-origin: top right;
  ${({ toggled }) =>
    !toggled
      ? `
      opacity: 0;
      transform: scale(0) translateY(-20%);
    `
      : `
      opacity: 1;
      transform: scale(1) translateY(-20%);
    `}
`;

export const Cell = styled('td')`
  position: relative;
`;
